import { useEffect } from "react";
import { withImageResizer } from "lib/utils";
import Link from "next/link";
import SearchInput from "./searchInput";

const Search = ({
  results,
  search,
  isMobileSearchOpen,
  handleSearch,
  setSearch,
}) => {
  const resultlist = results?.categories?.concat(results?.events);

  const listenToEsc = (e) => {
    if (e.key === "Escape") {
      setSearch("");
    }
  };

  useEffect(() => {
    if (search.length > 2) {
      window?.addEventListener("keydown", listenToEsc);
    } else {
      window?.removeEventListener("keydown", listenToEsc);
    }
    return () => {
      window?.removeEventListener("keydown", listenToEsc);
    };
  }, [search]);

  return (
    <>
      <div
        className={`hidden justify-between items-center w-full flex-wrap ${
          search.length > 2
            ? "!flex"
            : isMobileSearchOpen
            ? "phone-100:flex"
            : ""
        }`}
      >
        {" "}
        <div className="blurBackdrop overlay z-200 bg-whiteTransparent fixed h-screen w-screen backdrop-filter backdrop-blur-lg top-0 tablet-100:bg-white-100"></div>
        <section className="z-300 absolute h-screen top-0 py-10 px-14 w-full phone-300:px-4">
          <div className="hidden phone-100:block mt-12">
            <SearchInput
              handleSearch={handleSearch}
              search={search}
              setSearch={setSearch}
            />
          </div>
          <div className="pt-[101px] max-w-[1368px] m-auto phone-100:pt-8">
            {resultlist && resultlist.length === 0 && (
              <div className="font-bold pt-[101px] px-8 text-3xl text-center">
                Ei hakutuloksia
              </div>
            )}
            {resultlist && resultlist.length > 0 && (
              <ul className="flex flex-wrap justify-between pt-[101px] phone-100:pt-[20px]">
                {resultlist.map((item) => {
                  const isEvent = !!item.state;
                  const image = isEvent
                    ? item.previewImg
                      ? withImageResizer(item.previewImg, 640)
                      : "/images/bg1.jpeg"
                    : item.images?.card
                    ? withImageResizer(item.images.card, 640)
                    : "/images/bg1.jpeg";
                  const link = {
                    href: isEvent
                      ? `/?eventSlug=${item.urlName}&accountSlug=${item.account?.urlName}`
                      : `/?churchSlug=${item.account?.urlName}`,
                    as: isEvent
                      ? `/kirkko/${item.account?.urlName}/${item.urlName}`
                      : `/kirkko/${item.account?.urlName}`,
                  };
                  return (
                    <li key={item._id} id="search-item" className="flex w-full">
                      <Link href={link.href} as={link.as}>
                        <a className="flex w-full min-h-[169px] min-w-[420px] mb-[65px] phone-300:mb-0 px-8 phone-300:px-2 phone-300:min-w-[200px]">
                          <img
                            src={image}
                            className="object-cover	h-full w-full max-h-[169px] max-w-[169px] rounded-10 shadow-xl phone-300:max-w-[86px] phone-300:max-h-[86px] flex-1 bg-gray-100"
                          />
                          <div className="pl-[33px] flex-1">
                            <span className="text-blue-100 text-xl font-bold">
                              {isEvent && (
                                <>
                                  {item.state == 0 && <>SUORA</>}
                                  {(item.state == 1 || item.state == 2) && (
                                    <>MENNYT LÄHETYS</>
                                  )}
                                  {item.state == 3 && <>TULEVA LÄHETYS</>}
                                </>
                              )}
                              {!isEvent && <> KIRKKO</>}
                            </span>
                            <p className="font-bold text-[31px] phone-300:text-2xl mb-[10px]">
                              {isEvent ? (
                                <>{item.title}</>
                              ) : (
                                <>{item.account?.name}</>
                              )}
                            </p>
                            <p className="font-base">
                              {item.about ? (
                                <>
                                  {item.about?.description?.slice(0, 200)}
                                  {item.about?.description?.length > 100 && (
                                    <>...</>
                                  )}
                                </>
                              ) : (
                                <>
                                  {item.descriptionParsed?.content?.slice(
                                    0,
                                    200
                                  )}
                                  {item.descriptionParsed?.content?.length >
                                    100 && <>...</>}
                                </>
                              )}
                            </p>
                          </div>
                        </a>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            )}
            {/* <pre>{JSON.stringify(results, null, 2)}</pre> */}
          </div>
        </section>
        <style jsx>{`
          #search-item {
            flex-basis: 50%;
          }
          @media only screen and (max-width: 968px) {
            #search-item {
              flex-basis: 100%;
              padding: 0.5rem 0;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default Search;
